import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';

import { useDebounce } from '../../shared/hooks';
import { useField } from '@unform/core';
import { ParceirosService } from '../services/api/cadastros/ParceirosService';

type TAutoCompleteOption = {
  idparceiro: string;
  label: string;
  cfop: number; 
  diasvencimento: number;  
  cpf: string;
}

interface IAutoCompleteParceiroProps {
  isExternalLoading?: boolean;
  uuidparceiro?: (novoTextoselect: string | undefined) => void;
  cfops?: (novoTextoselect: number | undefined) => void;
  diasvencimento?: (novoTextoselect: number | undefined) => void;
  cpfs?: (novoTextoselect: string | undefined) => void;
}

export const AutoCompleteParceiro: React.FC<IAutoCompleteParceiroProps> = ({ isExternalLoading = false, uuidparceiro, diasvencimento, cfops, cpfs}) => {

  const { fieldName, registerField, defaultValue, error, clearError } = useField('idparceiro');


  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setIsLoading(true);
  
    debounce(() => {
      ParceirosService.getAllList(busca, selectedId)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(parceiro => ({ idparceiro: parceiro.idparceiro, label: parceiro.nome + ' - ' + parceiro.cpf, cfop: parceiro.cfop, diasvencimento: parceiro.diasvencimento, cpf:parceiro.cpf  })));
          }
        });
    });
  }, [busca, selectedId]);
 
  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idparceiro === selectedId); 
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);
   
  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idparceiro); uuidparceiro?.(newValue?.idparceiro); cpfs?.(newValue?.cpf); cfops?.(newValue?.cfop); diasvencimento?.(newValue?.diasvencimento); setBusca(''); clearError(); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Parceiros"
          error={!!error}  
          helperText={error}
        />
      )}
    />
  );
};